<template>
  <div class="px-[24px] py-[32px] bg-off-white rounded-[8px]">
    <span class="text-[24px] font-medium pb-[24px] block">
      {{ in18['page_checkout_cart_summary'] }}
    </span>
    <ul class="box__list">
      <li v-for="item in cart.items" class="box__list-item">
        <div class="box__item-title">
          {{ item.product.title }}
        </div>
        <span>{{ item.price_with_tax }}</span>
      </li>
    </ul><!-- ./box__list -->

    <div class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_product_quantity'] }}</div>
          <span>{{ cart.total_quantity }}</span>
        </li>
        <li class="box__list-item">
          <div>{{ in18['page_summary_price_without_tax'] }}</div>
          <span>{{ cart.formatted_total_price }}</span>
        </li>
        <li class="box__list-item">
          <div>{{ in18['page_summary_tax_rate'] }}</div>
          <span>{{ cart.formatted_tax_price }}</span>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div v-if="cart.shipping_price_with_tax > 0" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_shipping'] }}</div>
          <span>
            {{ cart.formatted_shipping_price_with_tax }}
          </span>
        </li>
        <li v-if="cart.shipping_method" class="box__list-item">
          <div class="fw-500 text-gray-dark">
            {{ cart.shipping_method.title }}
          </div>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div v-if="cart.payment_surcharge_price_with_tax > 0" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_payment_surcharge'] }}</div>
          <span>
            {{ cart.formatted_payment_surcharge_price_with_tax }}
          </span>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div v-if="cart.coupon_total_price_with_tax > 0" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_discount_price_wit_tax'] }}</div>
          <span class="discount_total_price">
            - {{ cart.formatted_coupon_total_price_with_tax }}
          </span>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div class="box__section">
      <ul class="box__list ">
        <li class="box__list-item  box__list-item--accent">
          <div><b>{{ in18['page_summary_total_price'] }}</b></div>
          <div><b class="text-dark">{{ cart.formatted_total_price_with_tax }}</b></div>
        </li>
      </ul>

      <button type="button" :disabled="inProgress"
              class="hidden lg:block w-full rounded-[8px] py-[14px] text-[16px] font-medium text-center text-white bg-lime-green hover:bg-lime-green-hover transition-all"
              @click="callProcessCheckout">
        {{ in18['page_summary_process_checkout_btn'] }}
      </button>

      <div class="text-center mt-4">
        <a :title="in18['page_summary_continue_shipping']" class="link  link--gray  text-sm hidden large:block"
           href="/">
          {{ in18['page_summary_continue_shipping'] }}
        </a>
      </div>
    </div><!-- ./box__section -->
  </div><!-- ./box -->
</template>


<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  cart: {
    type: Object,
    required: true,
  },
  in18: {
    type: Object,
    required: true,
  },
  inProgress: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['process-checkout']);

function callProcessCheckout() {
  emit('process-checkout');
}
</script>
